import Vue from 'vue';
import App from './App.vue';
import api from '@/utils/api';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueMoment from 'vue-moment'
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import apiUrl from "@/utils/apiUrl";
import Notifications from './plugins/notifications'
import Clipboard from 'v-clipboard';

import VDataTableCustomHeaderFiltersText
    from "@/components/VDataTable/HeaderFilters/VDataTableCustomHeaderFiltersText.vue";
import VDataTableCustomHeaderFiltersAutocomplete
    from "@/components/VDataTable/HeaderFilters/VDataTableCustomHeaderFiltersAutocomplete.vue";
import VDataTableCustomHeaderFiltersDate
    from "@/components/VDataTable/HeaderFilters/VDataTableCustomHeaderFiltersDate.vue";


File.prototype.convertToBase64 = function(callback){
    var reader = new FileReader();
    reader.onloadend = function (e) {
        callback(e.target.result, e.target.error);
    };   
    reader.readAsDataURL(this);
};

Vue.config.productionTip = false;
axios.defaults.withCredentials = true;
Vue.prototype.$log = process?.env?.NODE_ENV === 'development'
    ? (...args) =>  console.log('['+new Date().toISOString().replace(/^.+?T\d+:(.+?)Z/, '$1')+']' , ...args)
    : () => {};
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.use(VueAxios, axios);
Vue.use(Notifications);
Vue.use(Clipboard);

moment.locale('ru');
Vue.use(VueMoment, {moment});
Object.defineProperties(Vue.prototype, {
    $api: {
        get() {
            return api
        }
    },
    $apiUrl: {
        get() {
            return apiUrl;
        }
    }
});

Vue.component(VDataTableCustomHeaderFiltersText.name, VDataTableCustomHeaderFiltersText);
Vue.component(VDataTableCustomHeaderFiltersAutocomplete.name, VDataTableCustomHeaderFiltersAutocomplete);
Vue.component(VDataTableCustomHeaderFiltersDate.name, VDataTableCustomHeaderFiltersDate);

new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
}).$mount('#app');
